<template>
  <div class="el-col-24">
    <h5 class="warp-title">默认语设置</h5>
    <el-card class="box-card">
      <!-- 平台筛选 -->
      <div class="platform-options">
        <div class="option-item" v-for="(item, index) in platformList" :key="index" :class="{active:currentPlatformId === item.id}" @click="changePlatform(item.id)">{{item.name}}</div>
      </div>
      <!-- 表格数据 -->
      <el-table :data="defaultList" border style="width: 100%" class="mt20" v-loading="isTableLoading">
        <el-table-column label="开关">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.isOpen" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="role" label="角色">
            <template slot-scope="scope">
              <span>{{ scope.row.platformUserTypeName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="默认语内容">
          <template slot-scope="scope">
            <el-input v-model="scope.row.defaultSpeech" placeholder="请输入内容"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="primary" size="small" class="save-button" @click="submit" :loading="isSubmitLoading">保存设置</el-button>
    </el-card>
  </div>
</template>

<script>
import {queryEvaluateSetPage, ImDefaultSpeech} from '../../api/default/index'
export default {
  name: 'DefaultSet',
  mounted () {
    this.currentPlatformId = this.platformList[0] ? this.platformList[0].id : ''
    this.queryEvaluateSetPage()
  },
  computed: {
    platformList () {
      return this.$store.state.Auth.platformList
    }
  },
  data () {
    return {
      isTableLoading: false,
      isSubmitLoading: false,
      currentPlatformId: '',
      defaultList: []
    }
  },
  methods: {
    submit () {
      let defaultList = JSON.parse(JSON.stringify(this.defaultList))
      defaultList.forEach(item => {
        if (item.isOpen) {
          item.isOpen = 1
        } else {
          item.isOpen = 0
        }
      })
      let data = {
        batchUpdateList: JSON.stringify(defaultList)
      }
      this.isSubmitLoading = true
      ImDefaultSpeech(data).then(res => {
        this.isSubmitLoading = false
        if (res.data.resultCode === 0) {
          this.$message.success('保存成功')
          this.queryEvaluateSetPage()
        } else {
          this.$message.error(res.data.resultMessage)
        }
      }).catch(() => {
        this.isSubmitLoading = false
      })
    },
    changePlatform (id) {
      this.currentPlatformId = id
      this.queryEvaluateSetPage()
    },
    queryEvaluateSetPage () {
      let data = {
        platformTypeId: this.currentPlatformId
      }
      this.isTableLoading = true
      queryEvaluateSetPage(data).then(res => {
        if (res.data.resultCode === 0) {
          let defaultList = res.data.resultData
          defaultList.forEach(item => {
            if (item.isOpen === 1) {
              item.isOpen = true
            } else {
              item.isOpen = false
            }
          })
          this.defaultList = defaultList
        } else {
          this.$message.error(res.data.resultMessage)
        }
      }).finally(() => {
        this.isTableLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.box-card {
  .platform-options{
    display: flex;
    .option-item{
      font-size: 14px;
      color: #909399;
      height: 38px;
      line-height: 38px;
      text-align: center;
      padding: 0 20px;
      border: 1px solid #eee;
      margin-left: -1px;
      cursor: pointer;
      &.active{
        background-color: #E4E7ED;
        color: #409EFF;
      }
    }
  }
}
/deep/.el-tabs__content{
  padding: 15px 15px 30px;
}
.save-button{
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Default/Set.vue